import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button, MenuItem, Select } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../State/Store";
import { useEffect, useState } from "react";
import { fetchAllSellers, updateSellers } from "../../../State/admin/adminSellerSlice";
import { status } from "../../../types/sellerType";
import { accountStatus } from "./MainDashBoard";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(
  name: string,
  calories: number,
  fat: number,
  carbs: number,
  protein: number
) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
  createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
  createData("Eclair", 262, 16.0, 24, 6.0),
  createData("Cupcake", 305, 3.7, 67, 4.3),
  createData("Gingerbread", 356, 16.0, 49, 3.9),
];
type MainDashBoardProp = {
  selectedStatus: string ,
  setSelectedStatus:React.Dispatch<React.SetStateAction<string>>
}
export default function AdminDashBoardTable({selectedStatus,setSelectedStatus}:MainDashBoardProp) {
  const { adminSeller } = useAppSelector((store) => store);
  const [selectedValue, setSelectedValue] = useState("ACTIVE");
  const sellers = adminSeller?.sellers ?? [];

const dataToRender =
  selectedStatus === "ALL"
    ? sellers
    : sellers.filter(s => s.accountStatus === selectedStatus);
  const handleChange = (event: any,id:number|undefined) => {
    setSelectedValue(event.target.value);
    if(id!=undefined){
      dispatch(updateSellers({id,status:event.target.value}))
    }
  };
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(fetchAllSellers());
   
  }, []);

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Seller Name</StyledTableCell>
            <StyledTableCell>Email</StyledTableCell>
            <StyledTableCell align="right">Mobile</StyledTableCell>
            <StyledTableCell align="right">GSTIN</StyledTableCell>
            <StyledTableCell align="right">Business Name</StyledTableCell>
            <StyledTableCell align="right">Account Status</StyledTableCell>
            <StyledTableCell align="right">Change Status</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {dataToRender.map((seller) => (
            <StyledTableRow key={seller.id}>
              <StyledTableCell component="th" scope="row">
                {seller.sellerName}
              </StyledTableCell>
              <StyledTableCell>{seller.email}</StyledTableCell>
              <StyledTableCell align="right">{seller.mobile}</StyledTableCell>
              <StyledTableCell align="right">{seller.gstin}</StyledTableCell>
              <StyledTableCell align="right">
                {seller.businessDetails.businessName}
              </StyledTableCell>
              <StyledTableCell align="right">
                {seller.accountStatus}
              </StyledTableCell>
              <StyledTableCell align="right">
                <Select
                  labelId="demo-simple-select-label"
                  value={seller.accountStatus}
                  onChange={(event) => { handleChange(event,seller.id) }}
                >
                  {accountStatus.map((item) => (
                    <MenuItem key={item.status} value={item.status}>
                      {item.title}
                    </MenuItem>
                  ))}
                </Select>
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
